import React from 'react';
import { TRUSTED_BRANDS_LOGOS } from './constants';
import { TrustedByBrandsSectionProps } from '../types';

const TrustedByBrandsSection: React.FC<TrustedByBrandsSectionProps> = ({
  brands = TRUSTED_BRANDS_LOGOS,
}) => {
  const firstRowBrands = brands.slice(0, 3);
  const secondRowBrands = brands.slice(3);

  return (
    <div className="mx-auto px-4 mt-24 md:mt-16 sm:mt-8">
      <div className="text-center text-font-500 text-xl font-medium">
        Trusted by your favorite brands
      </div>

      <div className="border-none mt-0 pt-6 sm:border-none sm:px-0 mb-0 pb-0 md:flex-col sm:flex-col flex sm:items-baseline justify-center items-center">
        {/* First Row of Logos */}
        <div className="flex justify-around items-center h-16 sm:h-6 sm:mb-4 space-x-8 w-1/2 sm:pb-3 md:mb-4 md:w-full">
          {firstRowBrands.map((brand, index) => (
            <img
              key={`first-row-${index}`}
              className="object-scale-down sm:mx-auto h-10 sm:w-20 sm:h-auto md:w-25 md:h-auto"
              src={brand.src}
              width="100"
              height="40"
              alt={brand.alt}
              loading="lazy"
            />
          ))}
        </div>

        {/* Second Row of Logos */}
        <div className="flex justify-around items-center h-16 sm:h-6 space-x-8 w-1/2 md:w-full">
          {secondRowBrands.map((brand, index) => (
            <img
              key={`second-row-${index}`}
              className="object-scale-down sm:mx-auto h-10 sm:w-20 sm:h-auto md:w-25 md:h-auto"
              src={brand.src}
              width="100"
              height="40"
              alt={brand.alt}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedByBrandsSection;
